import theme, { actionButtonSx } from '@/theme'

import ChargingPointScreenTemplate from './template/ChargingPointScreenTemplate'
import { ChargingPointScreenProps } from './types'

import { Button } from '@mui/material'

import ChargingSessionBody from '../components/ChargingSessionBody'

const AvailableChargingPointScreen: React.FC<ChargingPointScreenProps> = (props) => {
  const handleOnClickStartCharging = () => {
    props.onStartCharging?.()
  }

  if (props.requiresConnectionToStart) {
    return (
      <ChargingPointScreenTemplate
        {...props}
        Body={
          <ChargingSessionBody
            message={
              <>
                Conector <b style={{ color: theme.palette.success.main }}>disponível</b> para uso.
                <br />
                Conecte o cabo ao veículo antes de iniciar o carregamento.
              </>
            }
          />
        }
      />
    )
  }

  return (
    <ChargingPointScreenTemplate
      {...props}
      Body={
        <ChargingSessionBody
          message={
            <>
              Conector <b style={{ color: theme.palette.success.main }}>disponível</b> para uso.
              <br />
              Pressione iniciar para começar o carregamento.
            </>
          }
        />
      }
      Footer={
        <Button
          variant="contained"
          color="primary"
          disableElevation
          fullWidth
          loading={props.isStartingCharging}
          onClick={handleOnClickStartCharging}
          sx={actionButtonSx}
        >
          Iniciar carregamento
        </Button>
      }
    />
  )
}

export default AvailableChargingPointScreen
